import { useEffect } from "react";

function looksLikeSdkUserActionError(event: any) {
  const msg =
    (typeof event?.message === "string" && event.message) ||
    (typeof event?.error?.message === "string" && event.error.message) ||
    (typeof event?.reason?.message === "string" && event.reason.message) ||
    "";

  // When the error is cross-origin, browsers often only give "Script error."
  const isScriptError = msg === "Script error." || msg === "Script error";

  // If we *do* have details, match the common SDK “pick X/Y” problem
  const isColumnError = msg.includes("reading 'column'") || msg.includes("column");

  return isScriptError || isColumnError;
}

function hideDevOverlayIframe() {
  const iframe = document.getElementById(
    "webpack-dev-server-client-overlay",
  ) as HTMLIFrameElement | null;

  if (iframe) {
    iframe.style.display = "none";
    iframe.style.pointerEvents = "none";
  }
}

function removeDevOverlayIframe() {
  const iframe = document.getElementById("webpack-dev-server-client-overlay");
  if (iframe?.parentNode) iframe.parentNode.removeChild(iframe);
}

export default function DevSdkOverlaySuppressor() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;

    // 1) Kill it once on mount (covers “already injected”)
    hideDevOverlayIframe();
    removeDevOverlayIframe();

    // 2) Keep killing it if it gets injected later
    const mo = new MutationObserver(() => {
      hideDevOverlayIframe();
      removeDevOverlayIframe();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // 3) Best-effort: stop the overlay from reacting to certain global errors
    const onErrorCapture = (e: ErrorEvent) => {
      if (!looksLikeSdkUserActionError(e)) return;
      e.preventDefault?.();
      e.stopImmediatePropagation?.();
      hideDevOverlayIframe();
      removeDevOverlayIframe();
    };

    const onRejectionCapture = (e: PromiseRejectionEvent) => {
      if (!looksLikeSdkUserActionError(e)) return;
      e.preventDefault?.();
      e.stopImmediatePropagation?.();
      hideDevOverlayIframe();
      removeDevOverlayIframe();
    };

    window.addEventListener("error", onErrorCapture, true);
    window.addEventListener("unhandledrejection", onRejectionCapture, true);

    return () => {
      mo.disconnect();
      window.removeEventListener("error", onErrorCapture, true);
      window.removeEventListener("unhandledrejection", onRejectionCapture, true);
    };
  }, []);

  return null;
}
